/* ---------------------------------------------------------------------------
   MEL'S FLOWERS NZ — PDP recipe block: keep the visible panel in step with the
   selected size.

   Design notes:

   This script only ever READS the selection. It never sets .checked and never
   dispatches a synthetic change. Dawn-family pickers upgrade to a custom
   element AFTER DOMContentLoaded and silently discard state set before they do;
   driving another component from outside is how the equivalent script broke on
   a sister store. Reading is immune to that.

   Matching, in order of preference:
     1. the radio's own value  — on this theme that is the exact option value
                                 ("Regular", "Deluxe", "Supersize"), so it
                                 matches the metafield ladder with no parsing
     2. .variant-title span    — this store's custom tile markup
     3. the label's text       — last resort, and the reason for the prefix
                                 match: the tiles append a price delta, so the
                                 label reads "Deluxe +$35.00"

   Progressive enhancement: with JavaScript off, every panel is visible and each
   is labelled with its size. The .is-synced class is what collapses that down.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  var ROOT = '[data-mel-recipe]';

  function clean(s) {
    return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function candidatesFor(input) {
    var out = [];
    if (input.value) out.push(clean(input.value));

    var label = null;
    if (input.id) {
      var sel = 'label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]';
      label = document.querySelector(sel);
    }
    if (!label) label = input.closest('label');
    if (label) {
      var title = label.querySelector('.variant-title');
      if (title) out.push(clean(title.textContent));
      out.push(clean(label.textContent));
    }
    return out.filter(Boolean);
  }

  function sync(root) {
    var panels = root.querySelectorAll('[data-mel-tier]');
    if (!panels.length) return;

    // Single-tier products have nothing to switch between.
    if (panels.length === 1) {
      root.classList.add('is-synced');
      panels[0].removeAttribute('data-mel-inactive');
      panels[0].classList.add('is-active');
      return;
    }

    var names = {};
    Array.prototype.forEach.call(panels, function (p) {
      names[clean(p.getAttribute('data-mel-tier'))] = p;
    });

    // Search the whole document: the picker is not necessarily a DOM ancestor
    // or sibling of this block, and on this store it is a custom tile widget.
    var checked = document.querySelectorAll('input[type="radio"]:checked');
    var target = null;

    for (var i = 0; i < checked.length && !target; i++) {
      var cands = candidatesFor(checked[i]);
      for (var j = 0; j < cands.length && !target; j++) {
        var text = cands[j];
        if (names[text]) { target = names[text]; break; }
        // "Deluxe +$35.00" — match on the leading tier name only.
        for (var key in names) {
          if (Object.prototype.hasOwnProperty.call(names, key) && text.indexOf(key) === 0) {
            target = names[key];
            break;
          }
        }
      }
    }

    // Nothing matched: leave every panel visible rather than showing the wrong
    // one. A shopper seeing all three sizes is a cosmetic problem; a shopper
    // seeing Supersize contents priced as Regular is not.
    if (!target) {
      root.classList.remove('is-synced');
      Array.prototype.forEach.call(panels, function (p) {
        p.removeAttribute('data-mel-inactive');
        p.classList.add('is-active');
      });
      return;
    }

    root.classList.add('is-synced');
    Array.prototype.forEach.call(panels, function (p) {
      if (p === target) {
        p.removeAttribute('data-mel-inactive');
        p.classList.add('is-active');
      } else {
        p.setAttribute('data-mel-inactive', '');
        p.classList.remove('is-active');
      }
    });
  }

  function syncAll() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT), sync);
  }

  // Any radio change anywhere re-syncs. Cheap, and immune to the picker being
  // re-rendered by the Section Rendering API.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') syncAll();
  }, true);

  // Shopify and Dawn-family themes both emit variant events; harmless if they
  // never fire.
  ['variant:change', 'variant:changed', 'product:variant-change', 'on:variant:change'].forEach(function (name) {
    document.addEventListener(name, syncAll);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  // The picker upgrades after first paint and may move the checked state.
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('variant-selects').then(syncAll).catch(function () {});
  }
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(syncAll);
  });

  // If the section is re-rendered, pick the new block up.
  //
  // Scoped to the product information column, NOT documentElement. Watching the
  // whole document meant every DOM change anywhere woke this up, and on this
  // page third-party scripts (GTM, Klaviyo, Clarity, Bing and the chat widget)
  // churn the DOM for roughly two seconds after a variant change. That produced
  // a stream of needless resyncs during exactly the window where the page
  // should feel responsive. The block only ever lives inside this container, so
  // nothing outside it can require a resync.
  if (window.MutationObserver) {
    var scope = document.querySelector('.product__info-container') ||
                document.querySelector('.product__info-wrapper') ||
                document.documentElement;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; syncAll(); });
    }).observe(scope, { childList: true, subtree: true });
  }
})();
